import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import Modal from "@/features/shared/components/Modal/Modal";
import ClientTableFilters from "@/features/client/components/ClientTableFilters";
import ClientTable from "@/features/client/components/ClientTable";
import ClientPagination from "@/features/client/components/ClientPagination";
import ClientForm from "@/features/client/components/ClientForm";
import useClients from "@/features/client/hooks/useClients";
import { IoMdAdd } from "react-icons/io";
import { toast } from "react-toastify";
const ClientsPage = () => {
    const [filters, setFilters] = useState({ denomination: '', email: '', ice: '' });
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);
    const [formError, setFormError] = useState(null);
    // Pass currentPage and filters to useClients; the hook refetches automatically when these values change.
    const { clients, meta, loading, error, handleAddClient, handleUpdateClient, handleDeleteClient, refetchClients, } = useClients(currentPage, filters, false, rowsPerPage);
    const handleFilterChange = (filterName, value) => {
        setFilters(prev => ({ ...prev, [filterName]: value }));
        setCurrentPage(1); // Reset to first page on filter change.
        // No manual fetch needed; the hook's query key changes and triggers a refetch automatically.
    };
    const handleResetFilters = () => {
        setFilters({ denomination: '', email: '', ice: '' });
    };
    const handleAddClientClick = () => {
        setSelectedClient(null);
        setIsModalVisible(true);
    };
    const handleEditUser = (client) => {
        setSelectedClient(client);
        setIsModalVisible(true);
    };
    const handleDelete = async (idClient) => {
        try {
            await handleDeleteClient(idClient);
            toast.success("Client supprimé");
        }
        catch (error) {
            toast.error(`Erreur : ${error.message}`);
        }
    };
    const handleSubmit = async (clientData) => {
        try {
            setFormError(null);
            if (selectedClient && clientData.id) {
                await handleUpdateClient(clientData.id, clientData);
                toast.success("Client modifié");
            }
            else {
                await handleAddClient(clientData);
                toast.success("Client ajouté");
            }
            setIsModalVisible(false);
        }
        catch (error) {
            setFormError(error.message);
            toast.error(`Erreur : ${error.message}`);
        }
    };
    if (loading) {
        return _jsx("div", { className: "p-4", children: "Chargement des clients..." });
    }
    if (error) {
        return (_jsxs("div", { className: "p-4 text-red-500", children: ["Erreur lors du chargement des clients : ", error, _jsx("button", { onClick: () => refetchClients(), className: "ml-4 bg-blue-500 text-white px-2 py-1 rounded", children: "R\u00E9essayer" })] }));
    }
    return (_jsxs("div", { className: "p-4 bg-gray-50 min-h-screen", children: [_jsxs("div", { className: "flex col-auto gap-4 mb-2", children: [_jsx("h4", { className: "text-xl font-bold", children: "Clients" }), _jsx("button", { onClick: handleAddClientClick, title: "Ajouter un nouveau client", className: "rounded", children: _jsx(IoMdAdd, { className: "bg-blue-500 text-white hover:bg-blue-600" }) })] }), _jsx(ClientTableFilters, { filters: filters, onFilterChange: handleFilterChange, onResetFilters: handleResetFilters }), _jsx(ClientTable, { clients: clients, onEdit: handleEditUser, onDelete: handleDelete }), meta && (_jsx(ClientPagination, { currentPage: meta.page ?? 1, totalPages: meta.totalPages ?? 1, limit: rowsPerPage, onPageChange: (page) => setCurrentPage(page), onLimitChange: (value) => {
                    setRowsPerPage(value);
                    setCurrentPage(1);
                } })), isModalVisible && (_jsx(Modal, { onClose: () => setIsModalVisible(false), children: _jsx(ClientForm, { initialData: selectedClient ?? undefined, onSubmit: handleSubmit, onCancel: () => setIsModalVisible(false) }) })), formError && (_jsxs("div", { className: "mt-4 p-3 bg-red-100 text-red-700 rounded", children: ["Erreur : ", formError] }))] }));
};
export default ClientsPage;
